import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { newsletterConfirm, formatApiError } from "@/lib/api";
import { CheckCircle, WarningCircle, SpinnerGap } from "@phosphor-icons/react";

export default function NewsletterConfirmPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading");
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setErr("No confirmation token found in the URL.");
      return;
    }
    newsletterConfirm(token)
      .then(() => setStatus("success"))
      .catch((ex) => {
        setErr(formatApiError(ex));
        setStatus("error");
      });
  }, [token]);

  if (status === "loading") {
    return (
      <div className="max-w-md mx-auto px-4 md:px-8 py-16 flex flex-col items-center gap-4">
        <SpinnerGap size={32} className="text-blue-600 animate-spin" />
        <p className="text-sm text-slate-400">Confirming your subscription…</p>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className="max-w-md mx-auto px-4 md:px-8 py-16">
        <div className="flex items-center justify-center w-12 h-12 bg-green-50 border border-green-200 mb-6 rounded-xl">
          <CheckCircle size={24} className="text-green-600" />
        </div>
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">
          / Subscribed
        </span>
        <h1 className="font-bold text-4xl mt-3 mb-3 text-slate-900">
          You're in!
        </h1>
        <p className="text-sm text-slate-500 mb-8 leading-relaxed">
          Your newsletter subscription is confirmed. Expect daily trending news — AI, Tech, Finance,
          World News, Health — straight to your inbox.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-3 bg-blue-600 hover:bg-blue-700 text-white text-xs uppercase tracking-wider font-bold transition-colors rounded-lg"
        >
          Read Today's News →
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-4 md:px-8 py-16">
      <div className="flex items-center justify-center w-12 h-12 bg-red-50 border border-red-200 mb-6 rounded-xl">
        <WarningCircle size={24} className="text-red-500" />
      </div>
      <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">
        / Confirmation failed
      </span>
      <h1 className="font-bold text-4xl mt-3 mb-3 text-slate-900">
        Link expired.
      </h1>
      <p className="text-sm text-slate-500 mb-6">
        {err || "This confirmation link is invalid or has expired."}
      </p>
      <Link to="/" className="text-xs text-slate-400 hover:text-slate-700 uppercase tracking-wider">
        ← Back to TrendMing
      </Link>
    </div>
  );
}
